import { useTranslation } from 'react-i18next'
import { buildMeta } from '#app/utils/seo.ts'
import { type Route } from './+types/tos.ts'

export const handle = { i18n: 'common' }

export const meta: Route.MetaFunction = () => {
	return buildMeta({
		title: 'Algemene voorwaarden',
		description:
			'Algemene voorwaarden van elseringnalda.nl, de portfolio-website van beeldend kunstenaar Else Ringnalda.',
		url: '/tos',
		noIndex: false,
	})
}

export default function TermsOfServiceRoute() {
	const { t } = useTranslation()
	return (
		<div className="container mx-auto max-w-2xl px-6 py-24">
			<h1 className="display mb-6" style={{ fontSize: 36 }}>
				{t('termsHeading')}
			</h1>
			<p style={{ color: 'var(--ink-soft)' }}>{t('contentComingSoon')}</p>
		</div>
	)
}
